var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{style:({'background-color': _vm.$store.getters.getColorPalette().backgroundColorCode, color: _vm.$store.getters.getColorPalette().accentCode}),attrs:{"fluid":""}},[_c(_vm.componentMap[_vm.emissionDetail.kpi],{tag:"component",attrs:{"emissionDetail":_vm.emissionDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }